(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gs-birlikte-giy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gs-birlikte-giy')) {
    class GsBirlikteGiy extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          const open = event.target.closest('[data-open]');
          const close = event.target.closest('[data-close]');
          const size = event.target.closest('.gs-with__size');
          if (open) this.toggle(open.closest('.gs-with__card'), true);
          if (close) this.toggle(close.closest('.gs-with__card'), false);
          if (size && !size.disabled) this.add(size);
        };
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      toggle(card, show) {
        this.querySelectorAll('.gs-with__card').forEach((c) => {
          const panel = c.querySelector('.gs-with__sizes');
          const btn = c.querySelector('[data-open]');
          const on = show && c === card;
          if (panel) panel.hidden = !on;
          if (btn) btn.setAttribute('aria-expanded', String(on));
        });
        if (show) {
          const first = card.querySelector('.gs-with__size:not([disabled])');
          if (first) first.focus();
        }
      }

      async add(button) {
        const card = button.closest('.gs-with__card');
        const status = card.querySelector('.gs-with__status');
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);
        const routes = (window.Theme && window.Theme.routes) || {};
        button.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(routes.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.variant), quantity: 1 }],
              sections: sectionIds.join(','),
            }),
          });
          const data = await response.json();
          if (data.status) throw new Error(data.description || data.message || 'Sepete eklenemedi.');
          let cart;
          try {
            cart = await (await fetch('/cart.js')).json();
          } catch (e) {
            cart = undefined;
          }
          const evt = new Event('cart:update', { bubbles: true });
          evt.detail = {
            resource: cart,
            sourceId: 'gs-birlikte-giy',
            data: { source: 'gs-birlikte-giy', itemCount: 1, sections: data.sections },
          };
          this.dispatchEvent(evt);
          if (status) status.textContent = 'Sepete eklendi';
          this.toggle(card, false);
        } catch (error) {
          if (status) status.textContent = error.message;
        } finally {
          button.removeAttribute('aria-busy');
          setTimeout(() => {
            if (status) status.textContent = '';
          }, 4000);
        }
      }
    }
    customElements.define('gs-birlikte-giy', GsBirlikteGiy);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gs-fiyat-set"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gs-fiyat-set')) {
    class GsFiyatSet extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          const link = event.target.closest('[data-scroll]');
          if (!link) return;
          event.preventDefault();
          const target = document.querySelector('gs-set-secici');
          if (!target) return;
          const top = target.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        };
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }
    }
    customElements.define('gs-fiyat-set', GsFiyatSet);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gs-kalip-secici"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gs-fit-switch')) {
    class GsFitSwitch extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          const link = event.target.closest('a[data-sizes]');
          if (!link) return;
          const size = this.currentSize();
          if (!size) return;
          let sizes;
          try {
            sizes = JSON.parse(link.dataset.sizes || '{}');
          } catch (e) {
            return;
          }
          const id = sizes[size];
          if (!id) return;
          event.preventDefault();
          window.location.href = link.dataset.url + '?variant=' + id;
        };
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      currentSize() {
        let map;
        try {
          map = JSON.parse(this.dataset.current || '{}');
        } catch (e) {
          map = {};
        }
        let id = new URLSearchParams(window.location.search).get('variant');
        const input = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        if (input && input.value) id = input.value;
        return id ? map[id] : null;
      }
    }
    customElements.define('gs-fit-switch', GsFitSwitch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gs-kombin-karti"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gs-kombin-karti')) {
    class GsKombinKarti extends HTMLElement {
      connectedCallback() {
        const node = this.querySelector('script[data-gs-colors]');
        try {
          this.colors = JSON.parse(node ? node.textContent : '[]');
        } catch (e) {
          this.colors = [];
        }
        this.colors.forEach((c) => {
          const v = String(c.hex || '').trim();
          const m = v.match(/^#?([0-9a-f]{6}|[0-9a-f]{3})/i);
          c.hex = m ? '#' + m[1] : '#cccccc';
        });
        this.colorIndex = Math.max(0, this.colors.findIndex((c) => c.current));
        this.discount = parseInt(this.dataset.discount, 10) || 0;
        this.picker = this.querySelector('.gs-combo__picker');
        this.openBtn = this.querySelector('[data-open]');
        this.done = this.querySelector('.gs-combo__done');
        this.errorEl = this.querySelector('.gs-combo__error');
        this.priceEl = this.querySelector('.gs-combo__combo-price');
        this.wasEl = this.querySelector('.gs-combo__was');

        this.onClick = (event) => {
          if (event.target.closest('[data-open]')) {
            this.toggle(this.picker.hidden);
            return;
          }
          const color = event.target.closest('.gs-combo__swatch');
          if (color) {
            this.colorIndex = parseInt(color.dataset.color, 10);
            this.render();
            return;
          }
          const size = event.target.closest('.gs-combo__size');
          if (size && !size.disabled) this.add(parseInt(size.dataset.variant, 10), size);
        };
        this.addEventListener('click', this.onClick);
        this.render();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      toggle(show) {
        this.picker.hidden = !show;
        this.openBtn.setAttribute('aria-expanded', String(show));
        if (show) {
          const first = this.picker.querySelector('button:not([disabled])');
          if (first) first.focus();
        }
      }

      escape(text) {
        return String(text).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch]);
      }

      render() {
        const color = this.colors[this.colorIndex];
        if (!color) return;
        const colorsBox = this.querySelector('.gs-combo__colors');
        const sizesBox = this.querySelector('.gs-combo__sizes');
        colorsBox.innerHTML =
          this.colors.length > 1
            ? this.colors
                .map(
                  (c, i) =>
                    '<button type="button" class="gs-combo__swatch' + (i === this.colorIndex ? ' is-active' : '') + '" data-color="' + i + '"' +
                    ' aria-label="' + this.escape(c.name) + '" aria-pressed="' + (i === this.colorIndex) + '">' +
                    '<span class="gs-combo__dot" style="background:' + c.hex + '"></span></button>'
                )
                .join('')
            : '';
        sizesBox.innerHTML = color.variants
          .map(
            (v) =>
              '<button type="button" class="gs-combo__size" data-variant="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
              this.escape(v.key) + '</button>'
          )
          .join('');
        const v = color.variants.find((x) => x.available) || color.variants[0];
        if (v && this.priceEl) {
          this.priceEl.textContent = this.money((v.price * (100 - this.discount)) / 100);
          if (this.wasEl) this.wasEl.textContent = this.money(v.price);
        }
      }

      async add(variantId, button) {
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);
        const routes = (window.Theme && window.Theme.routes) || {};
        button.setAttribute('aria-busy', 'true');
        if (this.errorEl) this.errorEl.hidden = true;
        try {
          const response = await fetch(routes.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionIds.join(',') }),
          });
          const data = await response.json();
          if (data.status) throw new Error(data.description || data.message || 'Sepete eklenemedi.');
          let cart;
          try {
            cart = await (await fetch('/cart.js')).json();
          } catch (e) {
            cart = undefined;
          }
          const evt = new Event('cart:update', { bubbles: true });
          evt.detail = {
            resource: cart,
            sourceId: 'gs-kombin-karti',
            data: { source: 'gs-kombin-karti', itemCount: 1, sections: data.sections },
          };
          this.dispatchEvent(evt);
          this.toggle(false);
          this.openBtn.hidden = true;
          if (this.done) this.done.hidden = false;
        } catch (error) {
          if (this.errorEl) {
            this.errorEl.textContent = error.message;
            this.errorEl.hidden = false;
          }
        } finally {
          button.removeAttribute('aria-busy');
        }
      }

      money(cents) {
        return Math.round(cents / 100).toLocaleString('tr-TR') + ' TL';
      }
    }
    customElements.define('gs-kombin-karti', GsKombinKarti);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gs-set-secici"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gs-set-secici')) {
    class GsSetSecici extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('.shopify-section') || document;
        this.format = this.dataset.moneyFormat || '{{amount}}';
        this.maxQty = parseInt(this.dataset.maxQty, 10) || 10;
        this.levels = this.parseJSON(this.dataset.levels, []).sort((a, b) => a.qty - b.qty);
        const colorsNode = this.querySelector('script[data-gs-colors]');
        this.colors = this.parseJSON(colorsNode ? colorsNode.textContent : '[]', []).map((c) => ({
          ...c,
          hex: this.cleanHex(c.hex),
        }));
        this.currentIndex = Math.max(0, this.colors.findIndex((c) => c.current));
        this.colorsBox = this.querySelector('.gs-set__colors');
        this.slotsBox = this.querySelector('.gs-set__slots');
        this.sizeLabel = this.querySelector('.gs-set__colors-size');
        this.hintEl = this.querySelector('.gs-set__hint');
        this.errorEl = this.querySelector('.gs-set__error');
        this.qtyEl = this.querySelector('.gs-set__qty');
        this.qty = parseInt(this.dataset.startQty, 10) || 1;
        this.slots = [];
        this.syncing = false;

        this.onChange = (event) => {
          if (event.target.matches('.gs-set__input')) this.setQty(parseInt(event.target.value, 10));
        };
        this.onClick = (event) => {
          const step = event.target.closest('.gs-set__step');
          if (step) {
            this.setQty(this.qty + parseInt(step.dataset.step, 10));
            return;
          }
          const swatch = event.target.closest('.gs-set__swatch');
          if (swatch && !swatch.disabled) {
            this.slots[parseInt(swatch.dataset.slot, 10)] = parseInt(swatch.dataset.color, 10);
            this.render();
          }
        };
        this.onVariantUpdate = () => setTimeout(() => this.render(), 0);
        this.onSubmit = (event) => {
          const form = event.target;
          if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
          if (!this.scope.contains(form)) return;
          this.writeThemeQuantity();
          if (this.isMixed()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.addSet(form);
          }
        };

        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
        this.scope.addEventListener('variant:update', this.onVariantUpdate);
        document.addEventListener('submit', this.onSubmit, true);

        this.observer = new MutationObserver((mutations) => {
          if (this.syncing) return;
          const outside = mutations.some((m) => !this.contains(m.target));
          if (!outside) return;
          clearTimeout(this.reTimer);
          this.reTimer = setTimeout(() => this.render(), 60);
        });
        this.observer.observe(this.scope, { childList: true, subtree: true });

        this.setQty(this.qty);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
        this.scope.removeEventListener('variant:update', this.onVariantUpdate);
        document.removeEventListener('submit', this.onSubmit, true);
        if (this.observer) this.observer.disconnect();
      }

      parseJSON(text, fallback) {
        try {
          return JSON.parse(text);
        } catch (e) {
          return fallback;
        }
      }

      cleanHex(value) {
        const v = String(value || '').trim();
        if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v)) return v;
        const m = v.match(/^#?([0-9a-f]{6})/i);
        return m ? '#' + m[1] : '#cccccc';
      }

      forms() {
        return Array.from(this.scope.querySelectorAll('form[data-type="add-to-cart-form"]'));
      }

      currentVariantId() {
        const form = this.forms()[0];
        const input = form ? form.querySelector('input[name="id"]') : null;
        return input ? parseInt(input.value, 10) : null;
      }

      currentKey() {
        const id = this.currentVariantId();
        const current = this.colors[this.currentIndex];
        if (!current) return null;
        const v = current.variants.find((x) => x.id === id) || current.variants.find((x) => x.available) || current.variants[0];
        return v ? v.key : null;
      }

      variantFor(colorIndex, key) {
        const color = this.colors[colorIndex];
        if (!color) return null;
        return color.variants.find((v) => v.key === key) || null;
      }

      setQty(qty) {
        if (!Number.isFinite(qty)) qty = 1;
        this.qty = Math.min(this.maxQty, Math.max(1, qty));
        while (this.slots.length < this.qty) this.slots.push(this.currentIndex);
        this.slots.length = this.qty;
        this.writeThemeQuantity();
        this.render();
      }

      writeThemeQuantity() {
        this.syncing = true;
        this.forms().forEach((form) => {
          let input = form.querySelector('input[name="quantity"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'quantity';
            form.appendChild(input);
          }
          if (String(input.value) !== String(this.qty)) {
            input.value = this.qty;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        this.syncing = false;
      }

      discountFor(qty) {
        let discount = 0;
        this.levels.forEach((l) => {
          if (qty >= l.qty && l.discount > discount) discount = l.discount;
        });
        return discount;
      }

      colorsActive() {
        return this.dataset.colorsEnabled === 'true' && this.colors.length > 1 && this.qty > 1;
      }

      setItems() {
        const key = this.currentKey();
        const ids = [];
        const slots = this.colorsActive() ? this.slots : new Array(this.qty).fill(this.currentIndex);
        slots.forEach((ci) => {
          const v = this.variantFor(ci, key);
          if (v) ids.push(v);
        });
        return ids;
      }

      isMixed() {
        if (!this.colorsActive()) return false;
        const items = this.setItems();
        return new Set(items.map((v) => v.id)).size > 1;
      }

      render() {
        const key = this.currentKey();

        this.slots = this.slots.map((ci) => {
          const v = this.variantFor(ci, key);
          return v && v.available ? ci : this.currentIndex;
        });

        this.querySelectorAll('.gs-set__input').forEach((r) => {
          r.checked = parseInt(r.value, 10) === this.qty;
        });
        const onCard = Array.from(this.querySelectorAll('.gs-set__input')).some((r) => r.checked);
        this.classList.toggle('gs-set--custom', !onCard);
        if (this.qtyEl && this.qtyEl.textContent !== String(this.qty)) this.qtyEl.textContent = this.qty;

        if (this.hintEl) {
          const d = this.discountFor(this.qty);
          const next = this.levels.find((l) => l.qty > this.qty && l.discount > d);
          const template = this.dataset.hint || '';
          if (template && next && !onCard) {
            const msg = template.replace('{n}', next.qty - this.qty).replace('{p}', next.discount);
            if (this.hintEl.textContent !== msg) this.hintEl.textContent = msg;
            this.hintEl.hidden = false;
          } else {
            this.hintEl.hidden = true;
          }
        }

        this.renderSlots(key);

        const items = this.setItems();
        const sum = items.reduce((s, v) => s + v.price, 0);
        const total = Math.round((sum * (100 - this.discountFor(this.qty))) / 100);
        this.updateButton(total);

        if (this.scope.classList) this.scope.classList.toggle('gs-set-mixed', this.isMixed());
      }

      renderSlots(key) {
        if (!this.colorsBox || !this.slotsBox) return;
        const active = this.colorsActive();
        this.colorsBox.hidden = !active;
        if (!active) return;

        if (this.sizeLabel) {
          const sizeText = key ? key + ' (tüm sette)' : '';
          if (this.sizeLabel.textContent !== sizeText) this.sizeLabel.textContent = sizeText;
        }

        const label = this.dataset.slotLabel || '{n}.';
        const html = this.slots
          .map((ci, s) => {
            const swatches = this.colors
              .map((c, i) => {
                const v = this.variantFor(i, key);
                const ok = !!(v && v.available);
                const on = ci === i;
                return (
                  '<button type="button" class="gs-set__swatch' + (on ? ' is-active' : '') + '"' +
                  ' data-slot="' + s + '" data-color="' + i + '"' +
                  ' aria-label="' + (s + 1) + '. ürün: ' + this.escape(c.name) + (ok ? '' : ' (stokta yok)') + '"' +
                  ' aria-pressed="' + on + '"' + (ok ? '' : ' disabled') + '>' +
                  '<span class="gs-set__dot" style="background:' + c.hex + '"></span></button>'
                );
              })
              .join('');
            return (
              '<div class="gs-set__slot">' +
              '<span class="gs-set__slot-n">' + this.escape(label.replace('{n}', s + 1)) + '</span>' +
              '<div class="gs-set__swatches">' + swatches + '</div>' +
              '<span class="gs-set__slot-name">' + this.escape(this.colors[ci] ? this.colors[ci].name : '') + '</span>' +
              '</div>'
            );
          })
          .join('');
        if (this.slotsBox.innerHTML !== html) this.slotsBox.innerHTML = html;
      }

      escape(text) {
        return String(text).replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch]);
      }

      updateButton(total) {
        if (this.dataset.buttonPrice !== 'true') return;
        const separator = this.dataset.buttonSeparator || ' · ';
        const text = separator + this.money(total);
        this.syncing = true;
        this.forms().forEach((form) => {
          const button = form.querySelector('button[name="add"]');
          if (!button) return;
          const holder = button.querySelector('.add-to-cart-text__content > span') || button.querySelector('.add-to-cart-text') || button;
          let tag = holder.querySelector('.gs-set-btn-price');
          if (!tag) {
            tag = document.createElement('span');
            tag.className = 'gs-set-btn-price';
            holder.appendChild(tag);
          }
          if (tag.textContent !== text) tag.textContent = text;
        });
        this.syncing = false;
      }

      async addSet(form) {
        const items = this.setItems();
        const grouped = {};
        items.forEach((v) => {
          grouped[v.id] = (grouped[v.id] || 0) + 1;
        });
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);
        const button = form.querySelector('button[name="add"]');
        if (button) button.setAttribute('aria-busy', 'true');
        if (this.errorEl) this.errorEl.hidden = true;

        const routes = (window.Theme && window.Theme.routes) || {};
        try {
          const response = await fetch(routes.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: Object.keys(grouped).map((id) => ({ id: Number(id), quantity: grouped[id] })),
              sections: sectionIds.join(','),
            }),
          });
          const data = await response.json();
          if (data.status) throw new Error(data.description || data.message || 'Sepete eklenemedi.');

          let cart;
          try {
            cart = await (await fetch('/cart.js')).json();
          } catch (e) {
            cart = undefined;
          }

          const evt = new Event('cart:update', { bubbles: true });
          evt.detail = {
            resource: cart,
            sourceId: 'gs-set-secici',
            data: { source: 'gs-set-secici', itemCount: items.length, sections: data.sections },
          };
          form.dispatchEvent(evt);
        } catch (error) {
          if (this.errorEl) {
            this.errorEl.textContent = error.message;
            this.errorEl.hidden = false;
          }
        } finally {
          if (button) button.removeAttribute('aria-busy');
        }
      }

      money(cents) {
        const fmt = (n, decimals, thousands, dec) => {
          const fixed = (n / 100).toFixed(decimals);
          const parts = fixed.split('.');
          const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return parts[1] ? whole + dec + parts[1] : whole;
        };
        return this.format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
          switch (key) {
            case 'amount_no_decimals':
              return fmt(cents, 0, ',', '.');
            case 'amount_with_comma_separator':
              return fmt(cents, 2, '.', ',');
            case 'amount_no_decimals_with_comma_separator':
              return fmt(cents, 0, '.', ',');
            case 'amount_with_period_and_space_separator':
              return fmt(cents, 2, ' ', '.');
            default:
              return fmt(cents, 2, ',', '.');
          }
        });
      }
    }
    customElements.define('gs-set-secici', GsSetSecici);
  }
  } catch(e) { console.error(e); }
})();

})();
